import { useState } from "react";

import { Box } from "@mui/material";

const Image = ({ src, imageWidth }) => {
  return (
    <Box sx={{ padding: "8px" }}>
      <img
        src={src}
        loading="lazy"
        style={{
          width: imageWidth ? `${imageWidth}px` : "300px",
          height: "auto",
        }}
      />
    </Box>
  );
};

export default Image;
